import { createBrowserHistory } from 'history';
import configureStore from './configureStore';
export const history = createBrowserHistory();
const store = configureStore(history);
export default store;
